import QuestionModel from "../../maths/QuestionModel";
import QuestionViewVerbal from "./QuestionViewVerbal";
import converter from "../../../libs/number-to-words";

export default class QuestionViewVerbalStats extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    isCorrect() {
        if (this._question.type === QuestionModel.TYPE_STATS_MOST_OFTEN) {
            let sum = 0;
            for (let i = 0; i < this._inputValue.length; i++) {
                sum += this._inputValue[i].value;
            }
            return sum === this._question.answer.value;
        }
        return this._inputValue === this._question.answer.value;
    }

    filterTemplate(x) {
        return true;
    }
}